<template>
  <input-select
    id="input:indBloqueado"
    v-model="payload.indBloqueado"
    :rules="[requiredRule]"
    :items="indBloqueadoOptions"
    label="Bloqueado"
    required
  />
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';

export default {
  name: 'BloqueioOptions',
  mixins: [RulesMixin],
  props: {
    payload: {
      type: Object,
      default() {
        return {
          indBloqueado: '',
        };
      },
    },
  },
  data: () => ({
    indBloqueadoOptions: [
      {
        value: true,
        text: 'Sim',
      },
      {
        value: false,
        text: 'Não',
      },
    ],
  }),
};
</script>
